<template>
  <authenticated-layout>
    <div class="row">
      <div class="col-12">
        <supermercados-ativos-cards />
      </div>
    </div>
  </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import SupermercadosAtivosCards from "./components/SupermercadosAtivosCards.vue";

export default {
  name: "SupermercadosAtivos",
  components: {
    AuthenticatedLayout,
    SupermercadosAtivosCards,
  },
};
</script>
